import React, { InputHTMLAttributes } from 'react';
import { ColorBox, ColorInput } from './ColorField.styles';

export function ColorField(props: InputHTMLAttributes<HTMLInputElement>): JSX.Element {
  return (
    <ColorBox>
      <ColorInput {...props} />
    </ColorBox>
  );
}
